import { supabase } from "@/integrations/supabase/client";
import { confirmCheckout } from "@/lib/payment";

// Confirmer une adhésion après paiement : la vérification auprès de Stripe,
// le reçu fiscal et les emails sont gérés côté serveur.
export async function confirmMembershipPayment(_membershipId: string, paymentId: string) {
  const result = await confirmCheckout(paymentId);
  if (result.status !== "paid") {
    throw new Error("Le paiement n'a pas pu être confirmé");
  }

  const { data: membershipData } = await supabase
    .rpc("get_membership_by_session", { session_id: paymentId })
    .maybeSingle();

  return {
    success: true,
    membershipId: result.id,
    membershipData,
  };
}
